import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IAppReduxState } from "../../../../../redux/store";
import { IAsyncData } from "../../../../../core/models";
import { apartmentRedux } from "../state/state";
import { IApartment } from "../../data/entities";
import { isSuccess } from "../../../../../core/redux";
import { BackImage } from "../../../../../components/back_image/back_image";
import { Page } from "../../../../../components/page/page";
import styled from "styled-components";
import { AreaItem } from "../components/area_item";
// import { Copyright } from "../../../../../components/copyright/copyright";
import { InteriorDesignModal } from "../components/interior_design_modal";
// import { AboutRepairModal } from "../components/about_repair_modal";
import { ApartmentTopNav } from "../components/apartment_top_nav";
import { ApartmentInfoPanel } from "../components/apartment_info_panel";
// import { ApartmentActions } from "../components/apartment_actions";
// import { BackLink } from "../../../../components/back_link";
import { ROUTES } from "../../../../../routes";
import { Compass } from "../../../../../components/compass";
import arrow_right from "../../../../../../assets/img/utils/arrow_right.svg";
import { useTranslation } from "react-i18next";
import { projectRedux } from "../../../project/ui/state/state";
import { IProject } from "../../../project/data/entities";
import { ApartmentActions } from "../components/apartment_actions";
import { RotateDetector } from "../../../../../components/rotate_detector";

const BREAK_POINT_MD = 700;
const BREAK_POINT_SM = 700;

// const Flex = styled.div`
//   flex: 1;
//   display: grid;
//   grid-template-columns: 1fr 2fr 1fr;
//   grid-gap: 30px;

//   @media (max-width: ${BREAK_POINT_MD}px) {
//     grid-template-columns: repeat(2, 1fr);
//   }

//   @media (max-width: ${BREAK_POINT_SM}px) {
//     grid-template-columns: 1fr;
//   }
// `;

const Right = styled.div`
  flex-shrink: 0;
  width: clamp(220px, 24%, 320px);
  margin-top: 30px;
  margin-bottom: 30px;
  color: white;

  @media (max-width: ${BREAK_POINT_MD}px) {
    order: 2;
  }

  @media (max-width: 800px) {
    margin: 0;
    font-size: 0.8rem;
    justify-self: center;
  }
`;

const Center = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: clamp(12px, 2vw, 28px);
  flex: 1;
  min-width: 0;
  width: 50%;
  height: 100%;
  justify-content: space-between;
  margin: 0 auto;
  padding: 0 1rem 0 0;
  align-self: start;

  @media (max-width: ${BREAK_POINT_MD}px) {
    order: 1;
    width: 100%;
    padding: 0 0.5rem;
  }
`;

const Left = styled.div`
  flex-shrink: 0;
  width: clamp(240px, 28%, 340px);
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0.75rem;
  align-self: start;
  background: #8ca2c2;
  height: 100%;

  @media (max-width: ${BREAK_POINT_MD}px) {
    order: 3;
    grid-column: 1 / span 2;
    justify-self: center;
  }

  @media (max-width: ${BREAK_POINT_SM}px) {
    grid-column: unset;
  }
`;

// const BottomRow = styled.div`
//   margin-top: 30px;
// `;

const PlanImageWrapper = styled.div`
  flex: 1;
  min-width: 0;
  height: min(66vh, 100%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Img = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: center;
`;

const StyledApartmentInfoPanel = styled(ApartmentInfoPanel)`
  @media (max-width: ${BREAK_POINT_MD}px) {
    border-radius: 23px;
  }
`;

const CompassWrapper = styled.div`
  width: 200px;
  margin-top: 1rem;
`;

export const ApartmentDetailPage: React.FC<any> = (props: any) => {
  const {
    apartmentId,
    projectId,
    sectorId,
    floorId,
    onPageChange,
    activeProject,
  } = props;

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language.slice(0, 2);

  const [isInteriorDesignModalOpen, setIsInteriorDesignModalOpen] =
    useState(false);
  // const [isAboutRepairModalOpen, setIsAboutRepairModalOpen] = useState(false);

  // function openInteriorDesignModal() {
  //   setIsInteriorDesignModalOpen(true);
  // }

  function closeInteriorDesignModal() {
    setIsInteriorDesignModalOpen(false);
  }

  // function openAboutRepairModal() {
  //   setIsAboutRepairModalOpen(true);
  // }

  // function closeAboutRepairModal() {
  //   setIsAboutRepairModalOpen(false);
  // }

  function onClickBack() {
    if (projectId && sectorId && floorId) {
      onPageChange({
        route: ROUTES.floor,
        param1: projectId,
        param2: sectorId,
        param3: floorId,
      });
    } else {
      onPageChange({});
    }
  }

  useEffect(() => {
    dispatch(apartmentRedux.actions.getDetail(apartmentId));
  }, [dispatch, apartmentId]);
  const apartmentDetailBranch = useSelector<
    IAppReduxState,
    IAsyncData<IApartment>
  >((state) => state.apartment.details);

  useEffect(() => {
    dispatch(projectRedux.actions.getDetail(projectId));
  }, [dispatch, projectId]);
  const projectSectorBranch = useSelector<IAppReduxState, IAsyncData<IProject>>(
    (state) => state.project.details,
  );

  return (
    <RotateDetector>
      <Page>
        <>
          {isSuccess(apartmentDetailBranch) && (
            <>
              <div
                className="project-portal d-flex justify-content-between"
                style={{ height: "80vh" }}
              >
                <Left className="z-1">
                  <h5 className="text-white text-center mt-2 mb-2">
                    {
                      projectSectorBranch.data?.sectors.find(
                        (x) => String(x.id) === String(sectorId),
                      )?.address[currentLang]
                    }
                  </h5>
                  <ApartmentTopNav
                    apartmentDetailBranch={apartmentDetailBranch}
                    projectId={projectId}
                    onPageChange={onPageChange}
                  />
                  <StyledApartmentInfoPanel
                    activeProject={activeProject}
                    apartmentDetailBranch={apartmentDetailBranch}
                  />
                  <ApartmentActions
                    apartmentDetailBranch={apartmentDetailBranch}
                  />
                </Left>

                <Center>
                  <BackImage />
                  <div className="z-1 mt-auto ms-3 mb-4">
                    <div className="more-info-btn p-2" onClick={onClickBack}>
                      <img
                        className=""
                        src={arrow_right}
                        style={{ transform: "rotate(-180deg)" }}
                        alt=""
                      />
                      <small>{t("common:go_back")}</small>
                    </div>
                  </div>
                  <PlanImageWrapper className="z-1">
                    <Img
                      src={apartmentDetailBranch.data?.image.url}
                      alt="Apartment plan"
                    />
                  </PlanImageWrapper>

                  <Right className="me-2 me-lg-5 z-1 text-end d-flex flex-column justify-content-between">
                    <div>
                      {apartmentDetailBranch.data?.areas.map((area) => (
                        <AreaItem key={area.id} area={area} />
                      ))}
                    </div>
                    <div>
                      <CompassWrapper>
                        <Compass
                          compass={apartmentDetailBranch.data?.compass}
                        />
                      </CompassWrapper>
                    </div>
                  </Right>
                </Center>
              </div>
            </>
          )}

          {/* <ApartmentActions
            apartmentDetailBranch={apartmentDetailBranch}
            openInteriorDesignModal={openInteriorDesignModal}
            openAboutRepairModal={openAboutRepairModal}
          /> */}

          <InteriorDesignModal
            show={isInteriorDesignModalOpen}
            onHide={closeInteriorDesignModal}
          />
          {/* <AboutRepairModal show={isAboutRepairModalOpen} onHide={closeAboutRepairModal} /> */}

          {/* <BottomRow>
            <Copyright />
          </BottomRow> */}
        </>
      </Page>

      {/* <BackLink
        href={`${ROUTES.floor}/${apartmentDetailBranch.data?.sectorId}/${apartmentDetailBranch.data?.floorId}`}
      /> */}
    </RotateDetector>
  );
};
